let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ffXbE")).then(() => parcelRequire('1Xuid'));